import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/landingPage/feature/FeatureDetailClient.tsx");
